import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import en from "./en.json"
import af from "./af.json"
import ar from "./ar.json"
import es from "./es.json"
import fr from "./fr.json"
import pt from "./pt.json"
import sw from "./sw.json"

import enEditor from "./editor/en"
import esEditor from "./editor/es"

import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector"
import moment from "moment"
import 'moment/min/locales.min'
import dateEs from 'date-fns/locale/es'
import dateAf from 'date-fns/locale/af'
import dateAr from 'date-fns/locale/ar'
import dateFr from 'date-fns/locale/fr'
import datePt from 'date-fns/locale/pt-BR' // Using Brazilian Portuguese as it's available

import Config from "../config"
import { registerLocale } from "react-datepicker"
import DateLocaleService from "../services/DateLocaleService"

const defaultLocale = 'en'
const locale = localStorage.getItem("i18nextLng")

// Register the locales
registerLocale('ar', dateAr)
registerLocale('af', dateAf)
registerLocale('es', dateEs)
registerLocale('fr', dateFr)
registerLocale('pt', datePt)
// Swahili locale is not available in date-fns, using English as fallback for date formatting

// Initialize date formatting with SA English default (en-za)
// This is separate from UI language preference
DateLocaleService.initialize()

// Keep UI language separate from date formatting
const formattedLocale = locale ? locale.split('-')[0] : defaultLocale
localStorage.setItem("i18nextLng", formattedLocale)

i18next
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    compatibilityJSON: 'v3', //? NOTE: Keeping old v3 version, helps with Pluralization because the alternative would be to rename all available keys 
    resources: {
      "af": {
        translations: af,
        editor: enEditor
      },
      ar: {
        translations: ar,
        editor: enEditor
      },
      en: {
        translations: en,
        editor: enEditor
      },
      "es": {
        translations: es,
        editor: esEditor
      },
      "fr": {
        translations: fr,
        editor: enEditor
      },
      "pt": {
        translations: pt,
        editor: enEditor
      },
      "sw": {
        translations: sw,
        editor: enEditor
      }
    },
    // Using fallbackLng function for better language fallback handling
    fallbackLng: (code) => {
      
      const fallbacks = []
      // Only use the pure base language when we find variants.
      const langPart = code.split('-')[0];
      if (langPart !== code) {
        fallbacks.push(langPart)

      }
      
      if (langPart !== defaultLocale) {
        fallbacks.push('en')
      }

      return fallbacks
    },
    debug: !Config.isProd,

    // Common namespace being used
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
      format: function(value, format) {
        if (format === 'uppercase') return value.toUpperCase()
        if(value instanceof Date) return moment(value).format(format)
        return value
      }
    }
  })

i18next.format = (key) => {
  return i18next.t("utils.format", {text: i18next.t(key)})
}

export default i18next